module.exports = __webpack_public_path__ + "static/img/role.2f3e9a8.png";


//////////////////
// WEBPACK FOOTER
// ./static/en/img/role3/zxrx/role.png
// module id = huTs
// module chunks = 7